//export const BASE_URL = "https://nyafestival-backend.onrender.com/api";
export const BASE_URL = "https://nyafest.ru/api";
export const FILES_URL = "https://nyafest.ru/u";
